import { Card, CardContent, Grid, Typography } from '@mui/material'
import React from 'react'

const HowToTeachScreen = () => {
  return (
    <Grid
      container
      direction="column"
      className="container"
      spacing="2"
      style={{ width: '100%', margin: '0' }}
    >
      <Grid item style={{ alignSelf: 'center' }}>
        <Typography
          component="h1"
          variant="h4"
          style={{
            textTransform: 'uppercase',
            fontWeight: '600',
            margin: 'auto',
            textAlign: 'center',
          }}
        >
          How to teach
        </Typography>
      </Grid>

      <Grid item style={{ maxWidth: '80%', margin: 'auto' }}>
        <Card>
          <CardContent>
            <Grid container direction='column' spacing={2}>
              <Grid item>
                <Typography variant="body1">
                  <strong>Step 1:</strong>&nbsp;Fill in all the information in
                  teacher’s profile.
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body1">
                  <strong>Step 2:</strong>&nbsp;Set up your available time for
                  teaching.
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body1">
                  <strong>Step 3:</strong>&nbsp;Set up all the types of lessons
                  that you want to teach, with price, duration… for each type of lesson.
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body1">
                  <strong>Step 4:</strong>&nbsp;Connect with student via skype
                  ID or phone number and show up on time to deliver the booked
                  lesson.
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body1">
                  <strong>Step 5:</strong>&nbsp;Teachers will receive payment in <strong>7-8 days</strong> from the finishing time of the lesson, if there are not any complaints from students, then the lesson is considered already successful.
                </Typography>
              </Grid>

              <Grid item>
                <Typography variant="body1" style={{ color: 'red' }}>
                  <strong>Important note:</strong>&nbsp;We will charge 5% of the lesson's teaching fee. This is for maintenance and updating our services.
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  )
}

export default HowToTeachScreen
